import { useCallback, useMemo } from 'react';

import { CrossOriginCommunication } from '../controllers/crossOriginCommunication/CrossOriginCommunicationController';
import { OutgoingMessage } from '../controllers/crossOriginCommunication/types';
import { useConfigSlice } from '../store/slices/config/selectors';

import { useIsTouchDevice } from './useIsTouchDevice';

export const useCashierCallbackConnected = (): (() => void) | undefined => {
  const cashierIframeEvent = useConfigSlice.getCashierIframeEvent();
  const cashierPopupEnabled = useConfigSlice.getCashierPopupEnabled();
  const cashierUrl = useConfigSlice.getCashierUrl();
  const cashierUrlMobile = useConfigSlice.getCashierUrlMobile();
  const cashierUrlFirst = useConfigSlice.getCashierUrlFirst();

  const isTouch = useIsTouchDevice();

  const cashierUrlToUse = useMemo(() => {
    if (isTouch && cashierUrlMobile) return cashierUrlMobile;
    if (cashierUrlFirst) return cashierUrlFirst;
    return cashierUrl;
  }, [cashierUrl, cashierUrlFirst, cashierUrlMobile, isTouch]);

  const isEnabled = useMemo(() => {
    if (!cashierPopupEnabled) return false;
    return !(!cashierIframeEvent && !cashierUrlToUse);
  }, [cashierIframeEvent, cashierPopupEnabled, cashierUrlToUse]);

  const callback = useCallback(() => {
    if (cashierIframeEvent) {
      CrossOriginCommunication.dispatch(OutgoingMessage.OpenCashier);
    } else if (cashierUrlToUse) {
      window.open(cashierUrlToUse, '_blank');
    }
  }, [cashierIframeEvent, cashierUrlToUse]);

  return isEnabled ? callback : undefined;
};
